<template>
  <div>
    <div class="core">
      <div class="link-top"></div>
      <div class="tit">{{ $t("home.partners") }}</div>
      <div class="link-top"></div>
    </div>
    <div class="partner-container">
      <div
        class="partner-wrapper scrolling-left"
        ref="scrollWrapper"
        @mouseover="pauseScroll"
        @mouseleave="resumeScroll"
      >
        <!-- 原始滚动内容 -->
        <div
          v-for="(partner, index) in imgUrl.rows"
          :key="index"
          class="partner-item"
        >
          <a v-if="partner.url" :href="partner.url" target="_blank">
            <img :src="getImagePath(index + 1)" alt="" />
          </a>
          <!-- 如果 url 为空，则不跳转 -->
          <img v-else :src="getImagePath(index + 1)" alt="" />
        </div>
        <!-- 克隆一份用于无缝滚动 -->
        <div
          v-for="(partner, index) in imgUrl.rows"
          :key="'clone-' + index"
          class="partner-item"
        >
          <a v-if="partner.url" :href="partner.url" target="_blank">
            <img :src="getImagePath(index + 1)" alt="" />
          </a>
          <!-- 如果 url 为空，则不跳转 -->
          <img v-else :src="getImagePath(index + 1)" alt="" />
        </div>
      </div>
    </div>
    <div class="partner-container1">
      <div
        class="partner-wrapper1 scrolling-left"
        ref="scrollWrapper1"
        @mouseover="pauseScroll1"
        @mouseleave="resumeScroll1"
      >
        <!-- 原始滚动内容 -->
        <div
          v-for="(partner, index) in imgUrl1.rows"
          :key="index"
          class="partner-item1"
        >
          <a v-if="partner.url" :href="partner.url" target="_blank">
            <img :src="getImagePath1(index + 1)" alt="" />
          </a>
          <!-- 如果 url 为空，则不跳转 -->
          <img v-else :src="getImagePath1(index + 1)" alt="" />
        </div>
        <!-- 克隆一份用于无缝滚动 -->
        <div
          v-for="(partner, index) in imgUrl1.rows"
          :key="'clone-' + index"
          class="partner-item1"
        >
          <a v-if="partner.url" :href="partner.url" target="_blank">
            <img :src="getImagePath1(index + 1)" alt="" />
          </a>
          <!-- 如果 url 为空，则不跳转 -->
          <img v-else :src="getImagePath1(index + 1)" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      imgUrl: {
        rows: Array(12).fill({}), // 模拟12个合作伙伴的图片数据
      },
      imgUrl1: {
        rows: Array(12).fill({}), // 模拟12个合作伙伴的图片数据
      },
      imgUrl: {
        rows: [
          { url: "https://www.brokenbound.com/#/HOME" },
          { url: "https://www.arc.ai/" },
          { url: "https://bitgert.com/" },
          { url: "https://www.soonverse.xyz/" },
          { url: "https://www.arris.club/#/index" },
          { url: "https://oceanpark.app/" },
          { url: "https://karatdao.com/" },
          { url: "https://amax.network/#/" },
          { url: "https://ailayer.xyz/" },
          { url: "https://fbpay.cc/" },
          { url: "https://www.a3sprotocol.xyz/" },
          { url: "https://cheersland.org/" },
          //   { url: "https://starnest.app/" },
          //   { url: "https://lightcycle.city/" },
        ],
      },
      imgUrl1: {
        rows: [
          { url: "https://starnest.app/" },
          { url: "https://fansland.io/" },
          { url: "https://www.cognixphere.ai/" },
          { url: "https://collably.network/" },

          //   { url: "https://www.a3sprotocol.xyz/" },

          
          { url: "https://lightcycle.city/" },
          { url: "https://www.4metas.io/" },
          { url: "https://star.co/" },
          //   { url: "https://cheersland.org/" },

          { url: "" },
          { url: "https://tunachain.io/" },
          { url: "https://www.olivewallet.io/Index" },
          { url: "https://linktr.ee/Click.FUN" },
          { url: "https://www.faircrypto.fund/Index" },
        ],
      },
    };
  },
  methods: {
    // 获取图片路径
    getImagePath(index) {
      return require(`@/assets/pc/partner/hp${index}.png`);
    },
    getImagePath1(index) {
      return require(`@/assets/pc/partner/pp${index}.png`);
    },
    // 暂停滚动
    pauseScroll() {
      this.$refs.scrollWrapper.style.animationPlayState = "paused";
    },
    // 恢复滚动
    resumeScroll() {
      this.$refs.scrollWrapper.style.animationPlayState = "running";
    },
    pauseScroll1() {
      this.$refs.scrollWrapper1.style.animationPlayState = "paused";
    },
    // 恢复滚动
    resumeScroll1() {
      this.$refs.scrollWrapper1.style.animationPlayState = "running";
    },
  },
};
</script>
<style scoped>
.partner-container {
  width: 1200px;
  overflow: hidden;
  margin: 0 auto;
  margin-top: 46px;
}

.partner-wrapper {
  display: flex;
  width: max-content;
  animation: scroll-left-to-right 85s linear infinite;
  animation-play-state: running; /* 默认动画状态为运行 */
}

/* 图片样式 */
.partner-item {
  min-width: 290px;
  height: 90px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 20px;
}

.partner-item img {
  width: 290px;
  height: 90px;
  object-fit: contain;
}

/* 左到右的无缝滚动 */
@keyframes scroll-left-to-right {
  0% {
    transform: translateX(0); /* 从左边开始 */
  }
  100% {
    transform: translateX(-50%); /* 滚动到一半 */
  }
}
</style>
<style scoped>
.partner-container1 {
  width: 1200px;
  overflow: hidden;
  margin: 0 auto;
  margin-top: 40px;
}

.partner-wrapper1 {
  display: flex;
  width: max-content;
  animation: scroll-right-to-right 85s linear infinite;
  animation-play-state: running; /* 默认动画状态为运行 */
}

/* 图片样式 */
.partner-item1 {
  min-width: 290px;
  height: 90px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 20px;
}

.partner-item1 img {
  width: 290px;
  height: 90px;
  object-fit: contain;
}

/* 从右向左的无缝滚动 */
@keyframes scroll-right-to-right {
  100% {
    transform: translateX(0); /* 从右边开始 */
  }
  0% {
    transform: translateX(-50%); /* 滚动到左边，克隆内容接上 */
  }
}
</style>

<style lang="less" scoped>
.core {
  display: flex;
  width: 1200px;
  margin: 0 auto;
  text-align: center;
  margin-top: 190px;
  .link-top {
    justify-content: center;
    width: 466px;
    margin-top: 14.5px;
    height: 1px;
    vertical-align: middle;
    background: #e8eaf2;
    border-radius: 0px 0px 0px 0px;
    opacity: 1;
  }
  .tit {
    
    height: 30px;
    font-size: 30px;
    font-family: Poppins-Bold, Poppins;
    font-weight: bold;
    color: #000000;
    line-height: 30px;
    -webkit-background-clip: text;
    // padding: 0 15px;
    margin: 0 30px;
    // border: 1px solid red;
    // box-sizing: border-box;
  }
}
</style>
